import { useState, useRef } from "react";
import { Dialog, DialogTitle, DialogActions, Button } from "@mui/material";
import React from "react";

export const useConfirmDelete = () => {
    const [open, setOpen] = useState(false);
    const resolveRef = useRef<(value: boolean) => void>(() => {});

    const confirm = () =>
        new Promise<boolean>((resolve) => {
            resolveRef.current = resolve;
            setOpen(true);
        });

    const handleClose = (result: boolean) => {
        setOpen(false);
        resolveRef.current(result);
    };

    const ConfirmDialog = () => (
        <Dialog open={open} onClose={() => handleClose(false)}>
            <DialogTitle>
                Are you sure you want to delete the uploaded Proposal file?
            </DialogTitle>

            <DialogActions>
                <Button onClick={() => handleClose(false)}>Cancel</Button>

                <Button color="error" onClick={() => handleClose(true)}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );

    return { confirm, ConfirmDialog };
};
